import Vue from 'vue'
import store from '@/store/store'
import { setValidator } from "./validators";

export const index = {
  fa: {
    name: 'فارسی',
    flag: 'IRI',
    code: 'fa',
    language: 'fa',
    validator: 'fa',
    phoneDetails: {
      countryCode: '+98',
      phoneNumberPrefix: '09',
      phoneNumberCount: 11
    },
    fonts: 'IRANSans, Archivo, Avenir, Helvetica, Arial, sans-serif',
    dir: 'rtl'
  },
  en: {
    name: 'English',
    flag: 'USA',
    code: 'en',
    language: 'en',
    validator: 'en',
    phoneDetails: {
      countryCode: '+98',
      phoneNumberPrefix: '09',
      phoneNumberCount: 11
    },
    fonts: 'Open Sans, Archivo, IRANSans, Avenir, Helvetica, Arial, sans-serif',
    dir: 'ltr'
  },
  /*  USA: {
      name: 'USA - English',
      flag: 'USA',
      code: 'USA',
      currency: 'USD ',
      language: 'en',
      validator: 'usa_en',
      phoneDetails: {
        countryCode: '+98',
        phoneNumberPrefix: '09',
        phoneNumberCount: 11
      },
      fonts: 'Open Sans, Archivo, IRANSans, Avenir, Helvetica, Arial, sans-serif',
      dir: 'ltr'
    }*/
}

export function createAvailableLocales() {
  let resultLocale = []
  Object.keys(index).forEach((item) => {
    resultLocale.push({
      name: index[item].name,
      code: item,
      iso: index[item].language,
      file: index[item].language,
      dir: index[item].dir,
      flag: index[item].flag,
      fonts: index[item].fonts,
      validator: index[item].validator,
      lang: index[item].language,
      locale: item
    })
  })

  return resultLocale
}

export const getDefaultLocale = () => {
  return 'en'
}

export function getAvailableLocales() {
  let resultLocale = []
  Object.keys(index).forEach((item) => {
    resultLocale.push({
      type: 'img',
      imgClass: 'h-4 w-5 ms-3 locale-flag',
      src: require(`@/assets/images/flags/${index[item].flag}.png`),
      label: index[item].name,
      lang: index[item].language,
      value: index[item].language,
      locale: item,
      region: item
    })
  })

  return resultLocale
}

export function setLocale(lang) {
  if (lang) {
    store.dispatch('setting/setClubInfo', { club_language: lang})
    store.dispatch('setLocale', index[lang])
    document.body.style.fontFamily = index[lang].fonts
    // Vue.prototype.$useral.rtl = locales[lang].dir === 'rtl'
    Vue.prototype.$vs.rtl = index[lang].dir === 'rtl'
    if (Vue.prototype.i18n) {
      Vue.prototype.i18n.locale = lang
    }
  }
}

export function setDefaultLocale() {
  const clubInfo = localStorage.getItem('clubInfo')
  if (clubInfo) {
    const userLang = JSON.parse(clubInfo).club_language
    if (userLang) {
      const availableLocales = getAvailableLocales()
      const availableLocalesKey = availableLocales.map(e => e.lang)
      let userLocaleIndex = availableLocalesKey.indexOf(userLang)
      if (userLocaleIndex > -1 && availableLocalesKey[userLocaleIndex] === userLang) {
        store.dispatch('setLocale', index[userLang])
      } else {
        const defaultLocale = getDefaultLocale()
        setLocale(defaultLocale)
      }
    } else {
      store.dispatch('setting/setClubInfo', { club_language: getDefaultLocale() || 'en' })
      setDefaultLocale()
    }
  } else {
    store.dispatch('setting/setClubInfo', { club_language: getDefaultLocale() || 'en' })
    setDefaultLocale()
  }
}

export function currency() {
  return store.state.setting.clubInfo.club_currency
}

export const locale = {
  locales: index,
  setLocale,
  setDefaultLocale,
  getAvailableLocales,
  getDefaultLocale,
  currency,
  validator: setValidator
}
